import { DefaultValue, getDefaultTransition, getShadow, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

interface OrganizationsSearchWrapperProps {
  visible?: boolean
}

export const OrganizationsSearchWrapper = styled.div<OrganizationsSearchWrapperProps>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  width: 600px;
  max-width: 80vw;
  border-radius: ${DefaultValue.BorderRadius};
  position: fixed;
  top: 25%;
  left: 50%;
  z-index: ${zIndex.GlobalSearch};
  transform: translate(-50%, ${({ visible }) => (visible ? 0 : '20px')});
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  will-change: transform opacity;
  ${getShadow('elevatedStrong')};
  ${getDefaultTransition('transform', 'opacity')}
`
